import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import Plotly from "plotly.js-dist";
import { AgGridReact, AgGridColumn } from "ag-grid-react";
import { Row, Col } from "reactstrap";
import { getContextMenuItems } from "../../../utils/getContextMenuItems";

export const WindTurbines = (props) => {
  const [dataFiltered, setDataFiltered] = useState([]);

  //  windspeed is not homogeneous across turbines, so take only the ones that are integer
  useEffect(() => {
    setDataFiltered(
      props.turbines.map((turbine) => {
        var obj = { ...turbine };
        var windspeed = [];
        var active_power = [];
        turbine.windspeed.forEach((x, idx) => {
          if (!String(x).includes(".")) {
            windspeed.push(x);
            active_power.push(turbine.active_power[idx]);
          }
        });
        obj["windspeed"] = windspeed;
        obj["active_power"] = active_power;
        return obj;
      })
    );
  }, []);

  // when dataFiltered is ready, create the arrays for chart and tables
  useEffect(() => {
    if (dataFiltered.length > 0) {
      // set chart
      var charData = dataFiltered.map((turbine) => {
        var obj = {
          x: turbine.windspeed,
          y: turbine.active_power,
          mode: "lines+markers",
          name: turbine.name,
          hovertemplate: `<i>${turbine.name}</i>" + "<br>NPV: %{y} €<extra></extra>`,
        };
        return obj;
      });
      var layout = {
        margin: { t: 80, b: 30, l: 80, r: 30 },
        showlegend: true,
        legend: {
          orientation: "h",
          x: window.innerWidth < 1600 ? 0.25 : 0.28,
          y: -0.16,
        },
        hovermode: "closest",
        title: {
          text: `Active Power (kW)`,
        },
        yaxis: {
          title: {
            text: "Active power (kW)",
            standoff: 10,
          },
        },
        xaxis: {
          title: {
            text: "Wind speed (m/s)",
            standoff: 15,
          },
        },
      };
      Plotly.newPlot("activePowerChart", charData, layout, {
        displaylogo: false,
      });
    }
  }, [dataFiltered]);

  return (
    <div style={{ padding: 20 }}>
      <h3 style={{ marginTop: 10, marginBottom: 0 }}>Wind Turbines</h3>
      <p style={{ marginTop: 2, marginBottom: 15 }}>
        Active power and structural details of the turbines
      </p>
      {dataFiltered.length > 0 ? (
        <div>
          <div
            id="activePowerChart"
            style={{
              width: "100%",
              height: window.innerWidth < 1600 ? 500 : 600,
              marginTop: 20,
            }}
          ></div>
        </div>
      ) : null}
      <div
        style={{
          width: "100%",
          marginTop: 30,
        }}
        className="ag-theme-balham"
      >
        <AgGridReact
          defaultColDef={{
            filter: true,
            sortable: true,
            resizable: true,
            minWidth: 180,
            maxWidth: 600,
            flex: 1,
            filterParams: { buttons: ["reset"] },
            // cellStyle: getCellStyle,
          }}
          getContextMenuItems={getContextMenuItems}
          rowData={dataFiltered}
          domLayout="autoHeight"
          getRowHeight={(params) => {
            return 24;
          }}
          popupParent={document.body}
          suppressDragLeaveHidesColumns={true}
          stopEditingWhenGridLosesFocus={true}
          singleClickEdit={true}
        >
          <AgGridColumn
            field="model_type"
            headerName="Model Type"
            minWidth={60}
          />
          <AgGridColumn
            field="nominal_power"
            headerName="Nominal power (KW)"
            filter={"agNumberColumnFilter"}
            type={"numericColumn"}
          />
          <AgGridColumn
            field="height_of_the_rotor"
            headerName="Height of the rotor (m)"
            filter={"agNumberColumnFilter"}
            type={"numericColumn"}
          />
          <AgGridColumn
            field="length_of_the_blade"
            headerName="Length of the blade (m)"
            filter={"agNumberColumnFilter"}
            type={"numericColumn"}
          />
        </AgGridReact>
      </div>
      <Row style={{ marginTop: 30 }}>
        {dataFiltered.map((turbine) => {
          return (
            <Col lg="4">
              <div>
                {turbine.model_type}
                <div
                  style={{
                    width: "100%",
                    marginTop: 10,
                  }}
                  className="ag-theme-balham"
                >
                  <AgGridReact
                    defaultColDef={{
                      filter: true,
                      sortable: true,
                      resizable: true,
                      minWidth: 180,
                      maxWidth: 600,
                      flex: 1,
                      filterParams: { buttons: ["reset"] },
                    }}
                    getContextMenuItems={getContextMenuItems}
                    rowData={turbine.windspeed.map((ws, idx) => {
                      return {
                        windspeed: ws,
                        active_power: turbine.active_power[idx],
                      };
                    })}
                    domLayout="autoHeight"
                    getRowHeight={(params) => {
                      return 24;
                    }}
                    popupParent={document.body}
                    suppressDragLeaveHidesColumns={true}
                    stopEditingWhenGridLosesFocus={true}
                    singleClickEdit={true}
                  >
                    <AgGridColumn
                      field="windspeed"
                      headerName="Wind speed (m/s)"
                    />
                    <AgGridColumn
                      field="active_power"
                      headerName="Active power (kW)"
                    />
                  </AgGridReact>
                </div>
              </div>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

const mapStateToProps = (state) => ({
  turbines: state.turbines.turbines,
});

export default connect(mapStateToProps)(WindTurbines);
